import Vue from 'vue'
import Router from 'vue-router'

// Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/home',
    },
    {
      path: '/home',
      name: 'Home',
      component:()=>import('../views/Home'),
    },
    {
      path: '/sl',
      name: 'SL',
      component:()=>import('../views/SL'),
    },
    {
      path: '/omics',
      name: 'Omics',
      component:()=>import('../views/Omics'),
    },
    {
      path: '/help',
      name: 'Help',
      component:()=>import('../views/Help'),
    },
    {
      path: '/contact',
      name: 'Contact',
      component:()=>import('../views/ContactUs'),
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js